import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class ClientListVm {
	clientId: number;
	clientName?: string;
	letterCodeId: number;
	letterCode?: string;
	canDelete: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'clientId': new UntypedFormControl(0, [...(validators['clientId'] ?? []), ...[Validators.required]]),
			'clientName': new UntypedFormControl(null, [...(validators['clientName'] ?? []), ...[]]),
			'letterCodeId': new UntypedFormControl(0, [...(validators['letterCodeId'] ?? []), ...[Validators.required]]),
			'letterCode': new UntypedFormControl(null, [...(validators['letterCode'] ?? []), ...[]]),
			'canDelete': new UntypedFormControl(false, [...(validators['canDelete'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['clientName', {"orderId":0,"sortColumn":"clientName","searchColumn":"clientName","includeInExcel":true,"exportColumn":null,"displayName":"Client Name","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['letterCode', {"orderId":1,"sortColumn":"letterCode","searchColumn":"letterCode","includeInExcel":true,"exportColumn":null,"displayName":"Letter Codes","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}],
			['canDelete', {"orderId":2,"sortColumn":"canDelete","searchColumn":"canDelete","includeInExcel":false,"exportColumn":null,"displayName":"Delete","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): ClientListVmFromFg {
		return new ClientListVmFromFg(fg);
	}
}

export class ClientListVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get clientId(): number {
		return this.fg.get('clientId').value;
	}
	set clientId(val) {
		this.fg.get('clientId').setValue(val);
	}

	get clientName(): string {
		return this.fg.get('clientName').value;
	}
	set clientName(val) {
		this.fg.get('clientName').setValue(val);
	}

	get letterCodeId(): number {
		return this.fg.get('letterCodeId').value;
	}
	set letterCodeId(val) {
		this.fg.get('letterCodeId').setValue(val);
	}

	get letterCode(): string {
		return this.fg.get('letterCode').value;
	}
	set letterCode(val) {
		this.fg.get('letterCode').setValue(val);
	}

	get canDelete(): boolean {
		return this.fg.get('canDelete').value;
	}
	set canDelete(val) {
		this.fg.get('canDelete').setValue(val);
	}
}
